import { base64encode } from './utils/base64';
import objToFormData from './utils/obj-to-formdata';
import { getUTCTime } from './utils/index';
import getEnv from './utils/get-env';
import getProject from './utils/get-project';
import getOS from './utils/get-os';
var DEFAULT_SERVER_HOST = 'https://wind.hlgdata.com';
var getTrackerData = function (project, device_id) {
    var now = Date.now();
    var page = "" + window.location.origin + window.location.pathname;
    var screen = window.screen;
    var utc = getUTCTime(now);
    var env = getEnv();
    return {
        "project": project,
        "path": "/wind",
        "sdk_version": "2.18.4",
        "runtime": {
            "os": getOS(),
            "model": '',
            "screen_width": screen.width,
            "screen_height": screen.height,
        },
        "report_time": now,
        "data": {
            "device_id": device_id,
            "is_first_day": 0,
            "env": env,
            "user_id": "",
            "is_login": 0,
            "referrer": "",
            "event_id": 39064,
            "event": "device_id_create",
            "device_id_timestamp": now,
            "channel_id": "",
            "organization": {
                "tenant_id": "",
                "org_id": "",
                "uc_id": "",
                "product_type": "",
                "role_list": []
            },
            "attributes": {
                "page_url": page,
                "page_params": {},
                "page_time": now,
                "page": page,
                "source_page": window.location.href,
                "detail": {
                    "page_name": "设备ID生成",
                },
                "ab_tags": [],
                "ums_user_id": "",
                "solution_version": "",
                "user_roles": [],
                "tenant_status": "",
                "tenant_id": ""
            },
            "timestamp": Date.now(),
            "utc_time": utc
        }
    };
};
export default (function (uuid) {
    try {
        var project = getProject();
        if (typeof window === 'undefined' || !project) {
            return;
        }
        var params = {
            gzip: 0,
            use_client_time: false,
            data: base64encode(JSON.stringify(getTrackerData(project, uuid))),
        };
        window.navigator.sendBeacon(DEFAULT_SERVER_HOST + "/wind", objToFormData(params));
    }
    catch (error) { }
});
